import React, { useCallback } from 'react';

import { FormHoc, Input, Select } from '../../atoms/Form';
import { useDialog } from '../../atoms/Dialog';
import {
    ConfigChatbot, ConfigChatbotFeaturesValidation, ConfigChatbotTextsValidation,
    StylesConfigChatbotValidation, configChatbotUpdate,
    ConfigChatbotFeaturesOnChatLinkClickActionEnum,
    ConfigChatbotFeaturesInternalLinksTargetEnum,
    ConfigChatbotFeaturesExternalLinksTargetEnum,
    ConfigChatbotFeaturesCloseModeEnum,
    ConfigChatbotFeaturesFooterModeEnum,
} from '../../../api';
import useApi from '../../../hooks/useApi';
import SendingContainer from '../../hoc/SendingContainer';
import { IConfRadek, IConfSekce } from './types';


interface IFormConfigProps {
    sekceObj: IConfSekce
    data: any
    reload: () => void
}

interface IFormRadekProps {
    radek: IConfRadek
    sekce: string
}

function FormConfigSekce({ sekceObj, data, reload }: IFormConfigProps) {
    //sekce: ['texts'], ['features'], ['styles', 'light'], ['styles', 'dark']
    const { call: updC, sending: sendingC, error: errorC } = useApi<void, ConfigChatbot>({});
    const { closeDialog } = useDialog();

    const dataSekce = sekceObj.sekce.length > 1 ? data[sekceObj.sekce[0]][sekceObj.sekce[1]] : data[sekceObj.sekce[0]];
    const onSubmit = useCallback(
        async (values: any) => {
            if (sekceObj.sekce.length > 1)
                data[sekceObj.sekce[0]][sekceObj.sekce[1]] = values;
            else
                data[sekceObj.sekce[0]] = values;
            const response = await updC(configChatbotUpdate(data));

            if (response !== false) {
                reload();
                closeDialog();
            }
        },
        [sekceObj, data, updC, reload, closeDialog]
    );

    const valSchema = sekceObj.sekce[0] === 'texts' ? ConfigChatbotTextsValidation :
        sekceObj.sekce[0] === 'features' ? ConfigChatbotFeaturesValidation : StylesConfigChatbotValidation;


    return (
        <SendingContainer sending={sendingC} error={errorC}>

            <FormHoc
                onSubmit={onSubmit}
                defaultValues={dataSekce}
                validationSchema={valSchema}
            >
                {
                    ({ submitHandler }) => (
                        <form
                            onSubmit={submitHandler}
                            noValidate>
                            {sekceObj.radky.map((radek: IConfRadek) =>
                                <div className='mt-20-bez-first' key={radek.idx}>
                                    <RadekForm sekce={sekceObj.sekce[0]} radek={radek} />
                                </div>

                            )}
                            <button
                                id='form-config-submit'
                                className='display-none' />
                        </form>
                    )
                }
            </FormHoc>
        </SendingContainer>
    );
}

function RadekForm({ sekce, radek }: IFormRadekProps) {
    if (sekce !== 'features') return (
        <Input
            key={radek.id}
            name={radek.id}
            label={radek.id}
            helper={radek.popis} />
    );

    const { bSelect, enumSelect }: { bSelect: boolean, enumSelect: any } = (() => {
        switch (radek.id) {
            case 'defaultOpen':
            case 'memoOpen':
                return ({ bSelect: true, enumSelect: ['true', 'false'] });
            case 'onChatLinkClickAction':
                return ({ bSelect: true, enumSelect: Object.values(ConfigChatbotFeaturesOnChatLinkClickActionEnum) });
            case 'internalLinksTarget':
                return ({ bSelect: true, enumSelect: Object.values(ConfigChatbotFeaturesInternalLinksTargetEnum) });
            case 'externalLinksTarget':
                return ({ bSelect: true, enumSelect: Object.values(ConfigChatbotFeaturesExternalLinksTargetEnum) });
            case 'closeMode':
                return ({ bSelect: true, enumSelect: Object.values(ConfigChatbotFeaturesCloseModeEnum) });
            case 'footerMode':
                return ({ bSelect: true, enumSelect: Object.values(ConfigChatbotFeaturesFooterModeEnum) });
            default:
                return ({ bSelect: false, enumSelect: [] });
        }
    })();

    if (bSelect) return (
        <Select
            key={radek.id}
            name={radek.id}
            label={radek.id}
            helper={radek.popis}
        >
            <option key='op1' value='' disabled>-</option>
            {
                enumSelect.map((item: string) => (
                    <option key={item} value={item}>{item}</option>
                ))
            }
        </Select>
    )

    return (
        <Input
            key={radek.id}
            name={radek.id}
            label={radek.id}
            helper={radek.popis} />
    );
}

export default FormConfigSekce;